import * as ActionType from '../actions/setup';
import SetupState from "../../constants/SetupState";
import Logger from "../../tools/logger";

const defaultState = {
	sectionState: SetupState.LOADING
};

/**
 * @description
 * get the setup data required for every page of the app.
 *
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function setup (state = defaultState, action) {
	let newState = {...state};

	switch (action.type) {

		case ActionType.REQUEST : {
			newState.sectionState = SetupState.LOADING;
			return newState;
		}

		case ActionType.SUCCESS : {
			newState = action.payload;
			newState.sectionState = SetupState.LOADED;
			return newState;
		}

		case ActionType.FAILURE : {

			if (action.payload && action.payload.status !== 401) {
				Logger.instance.error({
					component: 'setup',
					message: 'Could not load setup data'
				});
			}

			newState.sectionState = SetupState.ERROR_FETCHING;
			return newState;
		}

		default:
			return state;
	}
}
